$(document).ready(function(){
  $(".vs_pt-sizeguide__js").click(function(){
    $(".vs_pt-sizeguide__popup-js").addClass("active");
    $(".vs_pt-sizeguide__overlay").addClass("active");
    $("body").addClass("body_hidden");
    $(".js__header__stuck, .theme__header, .announcement-section").addClass("theme__header-zi");
  });
  $(".vs_pt-sizeguide__overlay, .vs_pt-sizeguide__cross-js").click(function(){
    $(".vs_pt-sizeguide__popup-js").removeClass("active");
    $(".vs_pt-sizeguide__overlay").removeClass("active");
    $("body").removeClass("body_hidden");
    $(".js__header__stuck, .theme__header, .announcement-section").removeClass("theme__header-zi");
    $(".vs_pt-size1__popup-js").removeClass("active");
  });

  $(".vs_pt-sizeguide__button-js").on("click", function () {
    var targetId = $(this).data("id");
    $(".vs_pt-size1__popup-js").removeClass("active");
    $(targetId.toLowerCase()).addClass("active");
    $(".vs_pt-sizeguide__popup-js").removeClass("active");
    $(".vs_pt-sizeguide__overlay").addClass("active");
  });

  $('.vs_pt-size1__popup-js').each(function () {
    var $popup = $(this);
    $popup.find(".vs_pt-size1__tab:first-child .vs_pt-size1__tab-button").addClass("active");
    $popup.find(".vs_pt-size1__content").hide();
    $popup.find(".vs_pt-size1__content:first").show();
    $popup.find(".vs_pt-size1__tab-button").on("click", function () {
      var targetId = $(this).attr("info-id");
      $popup.find(".vs_pt-size1__tab-button").removeClass("active");
      $(this).addClass("active");
      $popup.find(".vs_pt-size1__content").hide();
      $popup.find(targetId).show();
    });
  });
});
